<template>
    <div class="overlay" v-if="isOpen">
        <div class="overlay-content">
            <div class="flex"><b>Nome Terminal:</b> {{ terminalName }}</div>
            <div class="flex"><b>Entrada Reais:</b> {{ deposits | currency}}</div>
            <div class="flex"><b>Saida Reais:</b> {{ withdrawals | currency }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoScreen',
    data() {
        return {
            isOpen: false,
            terminalName: null,
            deposits: null,
            withdrawals: null,
            polling: null,
        }
    },
    created() {
        window.addEventListener('keydown', this.listenOnKey);
    },
    methods: {
        listenOnKey(e) {
            if (e.key === 'o') {
                e.preventDefault();
                if (!this.isOpen) {
                    this.getScreenInfo();
                } else {
                    this.isOpen = false;
                }
            }
        },
        closeAfterTimeout(seconds) {
            this.polling = setTimeout(() => {
                this.isOpen = false;
            }, seconds*1000)
        },
        getScreenInfo() {
            axios.get('/get-info').then((response) => {
                this.terminalName = response.data['terminal-name'];
                this.deposits = response.data['deposits'];
                this.withdrawals = response.data['withdrawals'];
                if (response.data['auto-close']) {
                    this.closeAfterTimeout(response.data['auto-close'])
                }
            }).finally(() => {
                this.isOpen = true;
            })
        }
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenOnKey);
        clearTimeout(this.polling)
    }
}
</script>

<style lang="scss" scoped>
.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1000001;
    background: #131313;
    color: #ddd;
    display: flex;
    justify-content: center;
    align-items: center;

    .overlay-content {
        font-size: 1.5rem;
        letter-spacing: 1px;
        padding: 1.5rem 2rem;
        border: 2px solid #7a7a7a;
        border-radius: 3px;

        .flex {

            &:first-child {
                margin-bottom: 1rem;
            }

            b {
                width: 250px;
            }
        }
    }
}
</style>
